module.exports = __webpack_public_path__ + "a3a5b5e75aaf40081d13ff449822578b.png";